import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { Provider } from 'src/typings';
import { ProviderService } from '../provider.service';

@Component({ selector: 'app-profile', templateUrl: './profile.component.html', styleUrls: ['./profile.component.scss'] })
export class ProfileComponent implements OnInit, OnDestroy {
  provider?: Provider;
  loading = false;
  saving = false;
  error = '';
  saveError = '';
  private id = 0;
  private revision = 0;
  private destroyed = false;
  private destroy$ = new Subject<void>();
  returnFilters: Record<string, string> = {};
  providerForm = this.fb.group({ description: ['', [Validators.required, Validators.pattern(/\S/), Validators.maxLength(255)]],
    taxNum: [''], orgNum: [''], fullDescription: [''] });

  constructor(private activateRoute: ActivatedRoute, private providerService: ProviderService,
    private fb: UntypedFormBuilder, private notificationService: NotificationService) {}

  ngOnInit() {
    this.activateRoute.queryParamMap.pipe(takeUntil(this.destroy$)).subscribe(query => {
      this.returnFilters = {};
      for (const [key, source] of Object.entries({ description: 'returnDescription', taxNum: 'returnTaxNum', orgNum: 'returnOrgNum', sort: 'returnSort', direction: 'returnDirection' })) {
        const value = query.get(source); if (value) this.returnFilters[key] = value;
      }
    });
    this.activateRoute.params.pipe(takeUntil(this.destroy$)).subscribe(params => { this.id = Number(params.id); void this.load(); });
  }
  ngOnDestroy() { this.destroyed = true; this.revision++; this.destroy$.next(); this.destroy$.complete(); }
  async load() {
    const revision = ++this.revision;
    this.loading = true; this.error = ''; this.saveError = ''; this.provider = undefined; this.saving = false;
    try {
      const provider = await firstValueFrom(this.providerService.getOne(this.id).pipe(takeUntil(this.destroy$)));
      if (this.destroyed || revision !== this.revision) return;
      if (!provider?.id) throw new Error('Not found');
      this.provider = provider; this.resetForm();
    } catch {
      if (!this.destroyed && revision === this.revision) this.error = 'Не удалось загрузить поставщика.';
    } finally { if (!this.destroyed && revision === this.revision) this.loading = false; }
  }
  resetForm() {
    if (!this.provider || this.saving) return;
    this.providerForm.reset({ description: this.provider.description || '', fullDescription: this.provider.fullDescription || '',
      taxNum: this.provider.taxNum || '', orgNum: this.provider.orgNum || '' });
    this.saveError = '';
  }
  async save() {
    if (!this.provider || this.saving) return;
    if (this.providerForm.invalid) { this.providerForm.markAllAsTouched(); return; }
    const revision = this.revision;
    const payload = { id: this.provider.id, ...this.providerForm.value, description: this.providerForm.value.description.trim() };
    this.saving = true; this.saveError = '';
    try {
      await firstValueFrom(this.providerService.save(payload).pipe(takeUntil(this.destroy$)));
      if (this.destroyed || revision !== this.revision) return;
      this.provider = { ...this.provider, ...payload };
      this.providerForm.markAsPristine();
      this.notificationService.notice('Поставщик сохранён');
    } catch {
      if (!this.destroyed && revision === this.revision) this.saveError = 'Не удалось сохранить реквизиты. Изменения остались в форме.';
    } finally { if (!this.destroyed && revision === this.revision) this.saving = false; }
  }
}
